define(["require", "exports", "knockout"], function (require, exports, ko) {
    "use strict";
    var CPPackageModuleModel = /** @class */ (function () {
        function CPPackageModuleModel(data) {
            this.Name = ko.observable();
            this.Description = ko.observable();
            this.Key = ko.observable();
            this.Group = ko.observable();
            this.Order = ko.observable();
            this.Selected = ko.observable();
            this.PackageDefault = ko.observable();
            var self = this;
            if (data) {
                ko.mapping.fromJS(data, CPPackageModuleModel.Mapping, self);
            }
        }
        CPPackageModuleModel.Mapping = {
            key: function (data) {
                return data.Id;
            },
            create: function (options) {
                return new CPPackageModuleModel(options.data);
            }
        };
        return CPPackageModuleModel;
    }());
    return CPPackageModuleModel;
});
//# sourceMappingURL=CPPackageModuleModel.js.map


//////////////////
// WEBPACK FOOTER
// ./build/models/CPPackageModuleModel.js
// module id = 177
// module chunks = 2